export default "assets/logo02-026a06d2.png";